import { createSlice } from '@reduxjs/toolkit';

interface IState {
	open: boolean;
}

const initialState: IState = {
	open: false,
};

const DownloadOtherSlice = createSlice({
	name: 'hook-downloadOther',
	initialState,
	reducers: {
		setDownloadOtherOpen: (state, { payload }) => {
			state.open = payload;
		},
	},
	extraReducers: builder => {},
});
export const { setDownloadOtherOpen } = DownloadOtherSlice.actions;
export default DownloadOtherSlice.reducer;
